// React libraries
import React from 'react';
import classnames from 'classnames';
// Component Style
import { useStyles } from "./SeparatorStyles";
export const Separator = (props) => {
    const classes = useStyles(props);
    const { id, type = "n400", width = 1, marginTop = "0px", marginBottom = "0px", style } = props;
    const separatorClasses = classnames({
        [classes.separator]: true,
        [classes[type]]: type
    });
    return (React.createElement("hr", { id: id, className: separatorClasses, style: Object.assign({ marginTop: marginTop, marginBottom: marginBottom, borderTopWidth: width }, style) }));
};
export default React.memo(Separator);
